// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YkKeqN{font:"font({theme: 'Body-M'})";flex-grow:1;text-align:center}.YkKeqN>:nth-child(1){margin-bottom:20px;font:"font(--noItemsMessageFont)";color:"color(--noItemsMessageColor)"}.YkKeqN>:nth-child(2){font:"font(--noItemsInfoFont)";color:"color(--noItemsInfoColor)"}.YkKeqN>:nth-child(2){cursor:pointer}.YkKeqN>:nth-child(2):not(:hover){text-decoration:underline}.YkKeqN.q2EAJv{margin:109px 0}.YkKeqN.wtYFrs{display:flex;flex-direction:column;justify-content:center;align-items:center;margin:50px 0}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fetchCardsErrorMessage": `YkKeqN`,
	"desktop": `q2EAJv`,
	"mobile": `wtYFrs`
};
export default ___CSS_LOADER_EXPORT___;
